import { useTheme } from 'styled-components';
import { ArrowRight, Close, Tooltip, Button } from '~components';
import { Props } from './types';

function Cnpj({ onClose, show, disabled, locked }: Props) {
  const theme = useTheme();

  if (locked) return null;

  return show ? (
    <Tooltip text="Limpar consulta" placement="right">
      <Close onClick={onClose} />
    </Tooltip>
  ) : (
    <Button
      type="submit"
      variant="icon"
      aria-label="Prosseguir"
      disabled={disabled}
    >
      <ArrowRight
        stroke={
          disabled
            ? theme.color.icon.neutral.weak
            : theme.color.icon.neutral.strong
        }
      />
    </Button>
  );
}

export default Cnpj;
